import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectStudents from "./SelectStudents/SelectStudents";
import Marking from "./Marking/Marking";
import { updateStepBulkMarking, updateStudentsSelectedBulkMarking } from "../../../../../../store/actions/class-marking.actions";

const BulkMarking = () => {
  const step = useSelector((state) => state?.classMarking?.stepBulk || 0);
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(updateStepBulkMarking(0))
    dispatch(updateStudentsSelectedBulkMarking())
  }, [])

  return (
    <div>
      {step === 0 &&
        <SelectStudents />
      }
      {step === 1 &&
        <Marking /> 
      }
    </div>
  );
};

export default BulkMarking;
